import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LinkContext } from "../../LinkProvider";
import AnimatedCTA from "../AnimatedCTA";
import ctaBg1 from "../../img/experience/cta-bg1.webp";
import ctaBg2 from "../../img/experience/cta-bg2.webp";

function CTA() {
  const { t } = useTranslation();
  const { link } = useContext(LinkContext);

  return (
    <section className="mt overflow-hidden pb-[60px] xl:pb-[160px]">
      {/* Text content */}
      <div className="glcontainer flex flex-col items-center text-center gap-[40px]">
        <div className="flex flex-col gap-[20px] items-center">
          <h2 className="font-['Montserrat'] font-black text-[24px] xl:text-[46px] text-[#0a0a0a] tracking-[-0.92px] uppercase leading-none xl:max-w-[808px]">
            {t("exp.cta.title")}
          </h2>
          <p className="font-['Inter'] font-normal text-[14px] xl:text-[18px] text-[#717171] leading-[1.4] xl:max-w-[643px]">
            {t("exp.cta.desc")}
          </p>
        </div>
        <AnimatedCTA href={link} mobile>{t("btn.start-trading")}</AnimatedCTA>
      </div>
    </section>
  );
}

export default CTA;
